import img01 from "../assets/images/trabaja/acabado.jpg"
import img02 from "../assets/images/trabaja/estructura.jpg"
import img03 from "../assets/images/trabaja/fibra-de-vidrio.jpg"
import img04 from "../assets/images/trabaja/pintura.jpg"
import img05 from "../assets/images/trabaja/mecanicoElectrico.jpg"
import img06 from "../assets/images/trabaja/ingenieria.jpg"
import img07 from "../assets/images/trabaja/administrativa.jpg"
export const TrabajaBlock = [
  {
    title: `ACABADO`,
    text: `Detalles e inspiración para el decorado interior de los omnibuses. 
    Desarrollo de habilidades creativas y prácticas.`,
    img: img01,
    UrlLink: `https://api.whatsapp.com/send?phone=51936812617&text=Trabaja con Nosotros - Hola Intramet deseo mas información de Acabado`,
  },
  {
    title: `ESTRUCTURA METÁLICA`,
    text: `Técnicas y procedimientos para el montaje del casco estructural de bus. 
    Desarrollo de habilidades para armar y montar piezas metálicas.`,
    img: img02,
    UrlLink: `https://api.whatsapp.com/send?phone=51936812617&text=Trabaja con Nosotros - Hola Intramet deseo mas información de Estructura Metalica`,
  },
  {
    title: `FIBRA DE VIDRIO`,
    text: `Moldeado de piezas decorativas y aerodinámicas.
    Desarrollo de habilidades de estética y combinación de colores.
    `,
    img: img03,
    UrlLink: `https://api.whatsapp.com/send?phone=51936812617&text=Trabaja con Nosotros - Hola Intramet deseo mas información de fibra de vidrio`,
  },
  {
    title: `PINTURA AUTOMOTRIZ`,
    text: `Decoración y embellecimiento exterior de un bus.
    Desarrollo de habilidades de tacto fino y coordinación ocular.
    `,
    img: img04,
    UrlLink: `https://api.whatsapp.com/send?phone=51936812617&text=Trabaja con Nosotros - Hola Intramet deseo mas información de pintura automotriz`,
  },
  {
    title: `MECÁNICO – ELÉCTRICO`,
    text: `Operación de los sistemas mecánicos, eléctricos y electrónicos.
    Desarrollo de habilidades de interpretación  técnica.`,
    img: img05,
    UrlLink: `https://api.whatsapp.com/send?phone=51936812617&text=Trabaja con Nosotros - Hola Intramet deseo mas información de mecanico electrico`,
  },
]
export const dataAreaAdministrativaTecnica = [
  {
    title: `INGENIERÍA`,
    text: `Diseño, procesos, gestión y seguridad en una industria manufacturera que exige valor agregado.
      Desarrollo de habilidades de gestión y liderazgo.
      `,
    img: img06,
    UrlLink:`https://api.whatsapp.com/send?phone=51936812617&text=Trabaja con Nosotros - Hola Intramet deseo mas información de area de produccion`
  },
  {
    title: `ADMINISTRATIVA  `,
    text: `Contabilidad financiera, logística, gestión del capital humano.
    Desarrollo de habilidades de gestión y liderazgo.
    `,
    img: img07,
    UrlLink:`https://api.whatsapp.com/send?phone=51936812617&text=Trabaja con Nosotros - Hola Intramet deseo mas información de administrativo`
  },
]
